import React, { useEffect, useRef, useState } from 'react'
import styles from './Project.module.css'
import { useNavigate } from 'react-router-dom';
import { ProjectInterface } from '../../../../lib/types/project';
import { urlFor } from '../../../../lib/sanity.client';
import { useTranslation } from '../../../../TranslationProvider';

export type ProjectProps = {
    project: ProjectInterface;
    index: number;
    setProjectTitle: React.Dispatch<React.SetStateAction<string>>;
    setHoverProject: React.Dispatch<React.SetStateAction<boolean>>;
}

const Project = (props: ProjectProps) => {

    const { currLang } = useTranslation(); // ✅ use context here
    const containerRefs = useRef<(HTMLDivElement | null)[]>([]);
    const navigate = useNavigate();
    const location = window.location; // Get the current location
    const containerRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [animationName, setAnimationName] = useState<string | null>(null);

    useEffect(() => {
        const container = containerRef.current;
        const content = contentRef.current;

        if (!container || !content) return;

        const containerWidth = container.clientWidth;
        const contentWidth = content.scrollWidth;

        const isOverflowing = contentWidth > containerWidth;
        setShouldAnimate(isOverflowing);

        if (isOverflowing) {
        const animationId = `scrollMarquee-${Math.floor(Math.random() * 100000)}`;
        const styleTag = document.createElement('style');

        styleTag.innerHTML = `
            @keyframes ${animationId} {
            0% {
                transform: translateX(0);
            }
            100% {
                transform: translateX(-${contentWidth / 2}px);
            }
            }
        `;

        document.head.appendChild(styleTag);
        setAnimationName(animationId);

        return () => {
            // Cleanup if unmounted or re-rendered
            document.head.removeChild(styleTag);
        };
        }
    }, [props.project]);

    const hoverProject = (isHovering: boolean) => {
        if(isHovering){
            props.setHoverProject(true);
            props.setProjectTitle(props.project.title);
        }else{
            props.setHoverProject(false);
        }
    }

    useEffect(() => {
        props.setHoverProject(false);
        props.setProjectTitle("");
    }, [location]);

    const handleClick = () => {
        props.setHoverProject(false);
        navigate(`/projects/${props.project.titleUrl}`)
    }
    
    return (
        <>
        <div 
            className={styles.project}
            onMouseEnter={() => hoverProject(true)}
            onMouseLeave={() => hoverProject(false)}
        >
            <div className={styles.project_overlay} onClick={() => handleClick()}>
                
            </div>
            <img src={`${urlFor(props.project.backgroundImage).url()}`} alt={props.project.title} ref={(el) => {(containerRefs.current[props.index] = el)}} />
            <div className={styles.marqueeContainer}  ref={containerRef}>
                <div className={`${styles.marqueeContent} ${shouldAnimate ? styles.animate : ''}`} ref={contentRef}
                    style={{
                        animation: shouldAnimate && animationName
                            ? `${animationName} 5s linear infinite`
                            : undefined,
                    }}
                >
                    <>
                    {props.project.typeProject.map((typeObj, index) => (
                        <span key={`tag1-${index}`} className={styles.tag}>{typeObj.type[currLang]}</span>
                    ))}
                    {/* Duplicate for seamless loop */}
                        {shouldAnimate && (
                            <>
                                {props.project.typeProject.map((typeObj, index) => (
                                    <span key={`tag2-${index}`} className={styles.tag}>{typeObj.type[currLang]}</span>
                                ))}
                            </>
                        )}
                    </>
                </div>
            </div>
        </div>
        </>
    );
};

export default Project
